<template style='text-align:left'>

  <v-layout column>   
    <v-flex xs12>
      <v-layout row  py-0 my-0>
        <v-flex ml-0 xs4 py-0 my-0>
          <v-select outlined :items="serviceTypes" label="Service"
           v-model="servicePeriod.service"></v-select>         
        </v-flex>
        <v-flex xs6 mx-0 pt-0> From/to
          <v-card color="indigo" dark flat>
            <EditDateMaybeRange v-bind:container='servicePeriod' v-bind:dateProp="'dateRange'" v-bind:alwaysRange="true"/>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>  
  </v-layout>
</template>        

<script>

import EditDateMaybeRange from "./EditDateMaybeRange" ; 

export default {

  components: { EditDateMaybeRange },
  props: {
    servicePeriod: null,
    person: null
  },

  data () {
    return {
      serviceTypes: ['AIF', 'Army (not AIF)', ' Australian Army Nursing Service', 
        'Australian Army Medical Women\'s Service', 'Australian Military Forces',
        'Australian Women\'s Army Service', 'Citizen Military Forces', 'Garrison', 'Interim Army', 
        'Merchant Navy', 'RAAF', 'RAN', 'Volunteer Defence Corps']
    }    
  },

  methods: { 
  }
}
</script>

<style>
.lite {color:#aaaaaa} ;
</style>



// WEBPACK FOOTER //
// src/components/Person/EditServicePeriod.vue